import styles from './Review.module.scss'

export default function Review({ review }) {
  const { author, content } = review
  return (
    <article className={styles.teaser}>
      <div className={styles.wrap}>
        <p className={styles.quote}>{content}</p>
        <p className={styles.author}>{author}</p>
      </div>
    </article>
  )
}
